/**
 * Product copy transcribed and condensed from the eight-page
 * "five pharma Agrovet literature_compressed (1).pdf" supplied by Forage.
 * This is display content, not medical advice.
 * Upload the original image/PDF assets separately before enabling downloads.
 */
export const FIVE_RANGE = [
  {
    slug: "cal-five-gold",
    name: "Chelated Cal Five Gold",
    shortName: "Cal Five Gold",
    type: "Liquid calcium & mineral supplement",
    audience: "Cattle and dairy livestock",
    colors: ["#0d3c30", "#176347"],
    description: "Chelated calcium, phosphorus and vitamins for nutritional support in dairy livestock.",
    benefits: ["Supports milk production and quality", "Helps support growth and feed conversion", "Supports bone strength and overall nutrition"],
    keyIngredients: ["Bio-active calcium", "Bio-active phosphorus", "Vitamins A, D3, E and B12", "Trace minerals and selected herbal extracts"],
    packs: ["500 ml", "1 L", "2 L", "5 L", "10 L", "20 L", "40 L"],
    brochurePage: 1
  },
  {
    slug: "heat-five-bolus",
    name: "Heat Five Bolus",
    shortName: "Heat Five",
    type: "Reproductive nutrition bolus",
    audience: "Cattle, buffalo, sheep and goats",
    colors: ["#6b1920", "#9c3340"],
    description: "Nutritional bolus formulated to support reproductive function and heat management.",
    benefits: ["Supports reproductive health and fertility", "Helps support hormonal balance", "Supports conception and productive performance"],
    keyIngredients: ["Vitamin E", "Vitamin K", "Chelated copper, cobalt and zinc", "Selenium", "Herbal extracts"],
    packs: ["1 × 8 bolus box"],
    brochurePage: 2
  },
  {
    slug: "utro-five-liquid",
    name: "Utro Five Liquid",
    shortName: "Utro Five",
    type: "Reproductive health liquid",
    audience: "Cattle, buffalo, sheep and goats",
    colors: ["#73153f", "#b52670"],
    description: "Herbal and nutritional liquid supplement for reproductive wellness.",
    benefits: ["Supports uterine and reproductive health", "Helps support fertility and breeding performance", "Supports overall productivity"],
    keyIngredients: ["Ashok", "Lodh", "Shatavari", "Ashwagandha", "Vitamins and minerals"],
    packs: ["500 ml", "1 L", "5 L"],
    brochurePage: 3
  },
  {
    slug: "liv-five-liquid",
    name: "LIV FIVE Liquid",
    shortName: "LIV FIVE",
    type: "Liver support liquid",
    audience: "Cattle, buffalo, sheep and goats",
    colors: ["#9a3d12", "#e77a27"],
    description: "A blend of herbs and nutrients formulated for liver function and digestive support.",
    benefits: ["Supports liver function", "Helps appetite and digestion", "Supports general health and feed conversion"],
    keyIngredients: ["Andrographis paniculata", "Phyllanthus niruri", "Silymarin", "Choline", "Vitamin C"],
    packs: ["500 ml", "1 L", "5 L"],
    brochurePage: 4
  },
  {
    slug: "five-digest-plus",
    name: "Five Digest Plus",
    shortName: "Five Digest Plus",
    type: "Digestive feed supplement",
    audience: "Cattle, buffalo, calves, sheep and goats",
    colors: ["#0d5372", "#58a544"],
    description: "Digestive enzymes, prebiotics, yeast and herbs formulated to support gut health.",
    benefits: ["Supports digestion and nutrient absorption", "Helps maintain healthy rumen function", "Supports feed utilisation and weight gain"],
    keyIngredients: ["Digestive enzymes", "Prebiotics (MOS)", "Saccharomyces cerevisiae yeast culture", "Herbal extracts", "Vitamin B complex"],
    packs: ["100 g", "250 g", "500 g", "1 kg", "5 kg", "25 kg"],
    brochurePage: 5
  },
  {
    slug: "five-zinc-b-liquid",
    name: "Five Zinc + B Liquid",
    shortName: "Five Zinc + B",
    type: "Zinc with B-complex liquid",
    audience: "Cattle, buffalo and other livestock",
    colors: ["#a32624", "#dc5241"],
    description: "Zinc and B-complex vitamins for nutritional support of growth and performance.",
    benefits: ["Supports growth and development", "Supports feed utilisation and appetite", "Helps support immunity and skin health"],
    keyIngredients: ["Zinc sulphate monohydrate", "Vitamins B1, B2, B6 and B12", "Niacinamide", "D-panthenol"],
    packs: ["100 ml", "250 ml", "500 ml", "1 L", "3 L", "5 L", "20 L"],
    brochurePage: 6
  },
  {
    slug: "vita-five-powder",
    name: "Chelated Vita Five Powder",
    shortName: "Vita Five",
    type: "Chelated mineral powder",
    audience: "Cattle and buffalo",
    colors: ["#8d2920", "#c85331"],
    description: "Vitamin and chelated mineral formulation for livestock nutrition.",
    benefits: ["Supports milk production", "Helps growth and general immunity", "Supports reproduction and overall animal health"],
    keyIngredients: ["Vitamins A, D3, E and B complex", "Calcium and phosphorus", "Zinc", "Copper and other trace minerals"],
    packs: ["500 g", "1 kg", "2.5 kg", "5 kg", "10 kg", "20 kg", "25 kg"],
    brochurePage: 7
  },
  {
    slug: "masti-five",
    name: "Masti Five",
    shortName: "Masti Five",
    type: "Udder health nutritional supplement",
    audience: "Cattle and buffalo",
    colors: ["#922e22", "#e35b36"],
    description: "A nutritional supplement formulated to support udder condition and animal wellness.",
    benefits: ["Supports udder health", "Supports overall immunity", "Formulated for recovery and udder condition support"],
    keyIngredients: ["Trisodium citrate", "Vitamins A, D3 and E", "Zinc and other trace minerals", "Amino acids", "Selected supportive ingredients"],
    packs: ["100 g", "250 g", "500 g", "1 kg", "5 kg", "25 kg"],
    brochurePage: 8
  }
];

export function fiveProduct(slug) {
  return FIVE_RANGE.find((product) => product.slug === slug);
}
